import Swiper, { Navigation, Autoplay, Pagination } from 'swiper'

Swiper.use([Navigation, Autoplay, Pagination]);

function initHeroCarousels() {

  const heroCarousels = Array.from(document.querySelectorAll('.js-hero-carousel'));

  heroCarousels.forEach(heroCarousel => {
    const slides = Array.from(heroCarousel.querySelectorAll('.js-hero-carousel-slide'));

    if (slides.length > 1) {
      const paginationEl = heroCarousel.querySelector('.js-hero-carousel-pagination');
      const navPrevEl = heroCarousel.querySelector('.js-hero-carousel-nav-prev');
      const navNextEl = heroCarousel.querySelector('.js-hero-carousel-nav-next');

      const swiper = new Swiper(heroCarousel, {
        loop: false,
        speed: 800,
        grabCursor: true,
        autoplay: {
          delay: 8000
        },
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        navigation: {
          prevEl: navPrevEl,
          nextEl: navNextEl,
        },
        breakpoints: {
          768: {
            spaceBetween: 12,
          }
        }
      });

      //stop autoplay on mouseover
      heroCarousel.addEventListener('mouseover', () => {
        swiper.autoplay.stop()
      });

      //start autoplay on mouseout
      heroCarousel.addEventListener('mouseout', () => {
        swiper.autoplay.start()
      });

      const controlsEffects = () => {

        slides.forEach(slide => {
          if (slide.classList.contains('swiper-slide-active')) {
            const activeSlideTheme = slide.dataset.theme;

            paginationEl.dataset.theme = activeSlideTheme;
            navPrevEl.dataset.theme = activeSlideTheme;
          }
        })
      };

      //Invoke controlsEffect - initial check
      controlsEffects();

      //Swiper API event listener invokes controlsEffect at the start of each slide change
      swiper.on('slideChangeTransitionStart', controlsEffects)
    }
  })
}
initHeroCarousels();
